// Renders a branded quote card to a canvas and returns a PNG data URL.

const wrapText = (ctx, text, maxWidth) => {
  const words = text.split(" ");
  const lines = [];
  let line = "";
  words.forEach((word) => {
    const test = line ? `${line} ${word}` : word;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = word;
    } else {
      line = test;
    }
  });
  if (line) lines.push(line);
  return lines;
};

export const generateQuoteCard = ({ text, author, source }) => {
  const W = 1200;
  const H = 1200;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  // Background — deep gradient
  const bg = ctx.createRadialGradient(W / 2, H / 2, 100, W / 2, H / 2, W);
  bg.addColorStop(0, "#1a1414");
  bg.addColorStop(0.6, "#0a0a0a");
  bg.addColorStop(1, "#000000");
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, H);

  // Subtle grain
  for (let i = 0; i < 1500; i++) {
    ctx.fillStyle = `rgba(255,255,255,${Math.random() * 0.025})`;
    ctx.fillRect(Math.random() * W, Math.random() * H, 1, 1);
  }

  // Top hairline
  ctx.strokeStyle = "rgba(255,255,255,0.18)";
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(120, 140);
  ctx.lineTo(W - 120, 140);
  ctx.stroke();

  // Brand mark
  ctx.fillStyle = "rgba(255,255,255,0.55)";
  ctx.font = "300 22px Georgia, serif";
  ctx.textAlign = "left";
  ctx.fillText("ETERNAL  NOW", 120, 110);
  ctx.textAlign = "right";
  ctx.fillStyle = "rgba(255,255,255,0.35)";
  ctx.font = "300 16px Georgia, serif";
  ctx.fillText("eternalnow.life", W - 120, 110);

  // Quote mark
  ctx.fillStyle = "rgba(255,255,255,0.12)";
  ctx.font = "italic 220px Georgia, serif";
  ctx.textAlign = "left";
  ctx.fillText("\u201C", 100, 350);

  // Body — quote text
  ctx.fillStyle = "#f4f1ec";
  ctx.font = "italic 44px Georgia, serif";
  ctx.textAlign = "left";
  const maxWidth = W - 280;
  const lines = wrapText(ctx, text, maxWidth);
  const lineHeight = 64;
  const totalH = lines.length * lineHeight;
  const startY = H / 2 - totalH / 2 + 20;
  lines.forEach((ln, i) => {
    ctx.fillText(ln, 140, startY + i * lineHeight);
  });

  // Bottom divider
  ctx.strokeStyle = "rgba(255,255,255,0.18)";
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(120, H - 200);
  ctx.lineTo(W - 120, H - 200);
  ctx.stroke();

  // Author + source
  ctx.fillStyle = "rgba(255,255,255,0.85)";
  ctx.font = "400 28px Georgia, serif";
  ctx.textAlign = "left";
  ctx.fillText((author || "").toUpperCase(), 140, H - 150);

  if (source) {
    ctx.fillStyle = "rgba(255,255,255,0.45)";
    ctx.font = "300 22px Georgia, serif";
    ctx.fillText(source, 140, H - 110);
  }

  return canvas.toDataURL("image/png");
};

export const downloadQuoteCard = (quote) => {
  const dataUrl = generateQuoteCard(quote);
  const link = document.createElement("a");
  link.href = dataUrl;
  const safe = (quote.author || "quote").replace(/\s+/g, "_").toLowerCase();
  link.download = `eternal-now-${safe}.png`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  return dataUrl;
};
